import React from "react";
import Chart from "react-apexcharts";
import { COLORES_ESTABLECIMIENTO } from "./constants";
import { formatCurrency, truncarNombre } from "./utils";

export default function GraficoParticipacionEstablecimientos(props) {
    const datos = props.datos || [];
    const moneda = props.moneda || "PEN";
    const labels = datos.map((item) => item.nombre);
    const series = datos.map((item) => Number((item.porcentaje || 0).toFixed(1)));
    const total = datos.reduce((acumulado, item) => acumulado + (item.total || 0), 0);

    const options = {
        chart: { type: "donut" },
        labels,
        colors: COLORES_ESTABLECIMIENTO,
        dataLabels: { enabled: false },
        legend: {
            position: "right",
            verticalAlign: "middle",
            fontSize: "13px",
            itemMargin: { vertical: 6 },
            formatter: (nombre, opts) => {
                const item = datos[opts.seriesIndex];
                // ApexCharts inserta este resultado como innerHTML, por eso
                // el <br/> corta la linea antes del monto.
                return `${truncarNombre(nombre)}<br/> ${formatCurrency(item.total, moneda)}`;
            },
        },
        plotOptions: {
            pie: {
                donut: {
                    labels: {
                        show: true,
                        total: {
                            show: true,
                            label: "Total",
                            formatter: () => formatCurrency(total, moneda),
                        },
                    },
                },
            },
        },
        // Los tooltips de dona no usan tooltip.x/tooltip.y.title (esos son
        // para charts de ejes); para truncar el nombre aqui tambien hay que
        // armar el contenido a mano.
        tooltip: {
            custom: ({ seriesIndex, w }) => {
                const nombre = truncarNombre(w.config.labels[seriesIndex]);
                const item = datos[seriesIndex] || { total: 0, porcentaje: 0 };
                const color = w.config.colors[seriesIndex % w.config.colors.length];
                return `
                    <div style="padding:8px 12px;">
                        <span style="color:${color};margin-right:6px;">●</span>
                        <strong>${nombre}</strong>: ${formatCurrency(item.total, moneda)} (${(item.porcentaje || 0).toFixed(1)}%)
                    </div>
                `;
            },
        },
        // En pantallas angostas (celular) la leyenda a la derecha aprieta la
        // dona; ahi se pasa a leyenda inferior en vez de forzar scroll horizontal.
        responsive: [
            {
                breakpoint: 576,
                options: {
                    legend: {
                        position: "bottom",
                        verticalAlign: "middle",
                        itemMargin: { horizontal: 8, vertical: 4 },
                    },
                },
            },
        ],
    };

    // react-apexcharts compara las options con JSON.stringify, que ignora las
    // funciones: si solo cambian los montos (formatters de leyenda y total),
    // no re-renderiza. La key obliga a remontar la dona cuando cambian los datos.
    const claveDatos = datos.map((item) => `${item.nombre}:${item.total}`).join("|");

    return (
        <Chart
            key={`${moneda}-${claveDatos}`}
            options={options}
            series={series}
            type="donut"
            width="100%"
            height={320}
        />
    );
}
